import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { _ } from '_locales';
import { colors } from '_styles';
import moment from 'moment';
import HOC from '_HOC';
import SingleCheckbox from '../../../components/SingleCheckbox';

const Container = styled.div`
    width: 100%;
    max-width: 580px;
    padding: 45px 35px;
    box-sizing: border-box;
    margin: 0 auto;
    min-height: 350px;
`;

const Header = styled.h2`
    font-size: 24px;
    font-weight: 400;
    font-family: Roboto, sans-serif;
    margin-bottom: 15px;
`;

const Description = styled.h4`
    color: #747474;
    font-size: 16px;
    font-weight: 500;
    font-family: Roboto, sans-serif;
    margin-top: 5px;
    margin-bottom: 25px;
`;

const Button = styled.button`
    gap: 10px;
    width: 100%;
    height: auto;
    border: none;
    display: flex;
    padding: 15px;
    cursor: pointer;
    min-height: 50px;
    margin-bottom: 5px;
    box-sizing: border-box;
    background-color: #fff;
    border-bottom: 1px solid #dbdbdb;
    padding-left: 0 !important;
    align-items: center;
`;

const Title = styled.span`
    display: inline-block;
    margin: 0;
    padding: 0;
    font-size: 16px;
    text-align: left;
    font-family: Roboto, sans-serif;
`;

const NextButton = styled.button`
  position: relative;
  font-size: 14px;
  padding: 20px 0;
  background-color: ${colors.RC_ACTION};
  cursor: pointer;
  border: none;
  border-radius: 8px;
  color: #fff;
  width: 160px;
  height: 39px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px auto 15px;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

const MissedCollections = ({ config, props }) => {
  const { history } = props;
  const { collection } = config;

  const [selectedCollections, setSelectedCollections] = useState([]);

  // Redirect to the next screen if only one collection is available
  useEffect(() => {
    const collectionKeys = Object.keys(collection)
      .filter((item) => collection[item].details.path?.includes('collection'));

    if (collectionKeys?.length === 1) {
      const singleCollection = [+collectionKeys[0].split('-')[1]];
      history.push('/help/missed-collection-day', {
        selectedCollections: singleCollection
      });
    }
  }, []);

  const onChange = (event, collection) => {
    if (event.target.checked) {
      setSelectedCollections((s) => [...s, collection]);
    } else {
      setSelectedCollections((s) => s.filter((c) => c !== collection));
    }
  };

  const nextButtonHandler = () => {
    history.push('/help/missed-collection-day', {
      selectedCollections
    });
  };
  return (
    <Container>
      <Header>{_('help.which_collection_was_missed')}</Header>
      <Description>{_('help.please_select_any_collection_that_you_want')}</Description>

      <ul style={{ padding: 0 }}>
        {
          Object.keys(collection)
            .filter((item) => ((collection[item].details.path) ? collection[item].details.path.includes('collection') : null))
            .map((coll) => (
              <li style={{ listStyle: 'none', padding: '7px 0' }}>
                <SingleCheckbox
                  id={`checkbox-${collection[coll].title}`}
                  name="checkbox"
                  onClick={(event) => onChange(event, +coll.split('-')[1])}
                  label={<Title>{collection[coll].title}</Title>}
                />
              </li>
            ))
        }
      </ul>
      <NextButton disabled={!selectedCollections.length} onClick={() => nextButtonHandler()}>{_('help.next')}</NextButton>

    </Container>
  );
};

export default HOC(MissedCollections);
